<template>

    <div :class="{'enlarge-menu': enlargeMenu, 'enlarge-menu-all': isScreenWidthMd}">
        <LeftBar :confirmView="true" @enlargeMenu="enlargeMenu = true"/>
        <AppHeader :confirmView="true" @enlargeMenu="enlargeMenu = !enlargeMenu"/>
        <RightBar/>
        <div class="page-wrapper">
            <div class="page-content-tab" style="background-color: white">
                <div class="container-fluid" style="background-color: white">
                    <!--   <transition name="in-out-translate-fade" mode="out-in">-->
                    <b-row class="row align-items-center">
                        <b-col class="text-center">
                            <img alt="logo-small"
                                 class="logo-sm align-self-center"
                                 height="134"
                                 src="@/assets/images/logo/s-stark-white.png"
                            />
                        </b-col>
                    </b-row>
                    <b-row class="row align-items-center">
                        <b-col class="text-center">
                            <img alt="not-found"
                                 class="logo-sm align-self-center"
                                 height="334"
                                 src="@/assets/images/404.png"
                                 v-if="userNotFound"
                            />
                        </b-col>
                    </b-row>
                    <div class="card-body" v-if="formShow">
                        <transition mode="out-in" name="in-out-translate-fade">
                            <component :form="formComponent"
                                       :packCountryDomain="packCountryDomain"
                                       @getPackCountryDomain="getPackCountryDomainBackOffice"
                                       @next="next"
                                       @previous="previous"
                                       v-bind:is="view"
                                       v-if="formComponent"
                            ></component>
                        </transition>
                    </div>
                    <div v-else>
                        <Loading/>
                    </div>

                    <!-- </transition>-->
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import PackInfo from '../../components/shared/formInfo/PackInfo.vue';
    import OrganisationInfo from '../../components/shared/formInfo/OrganisationInfo.vue';
    import ClientInfo from '../../components/shared/formInfo/ClientInfo.vue';
    import InfosCommercial from '../../components/shared/formInfo/InfosCommercial.vue';
    import AppHeader from '../../components/layouts/navbar/AppHeader';
    import LeftBar from '../../components/layouts/leftbar/LeftBar';
    import RightBar from '../../components/layouts/rightbar/RightBar';
    import {titles} from '../../utils/general/titles.js';
    import {roles} from '../../utils/general/roles';
    import Tab from '../common/Tab';
    import {getClient} from '../shared/services/user.service';
    import {commercial} from '../shared/models/commercial';
    import {subscription} from '../shared/models/subscription';
    import Loading from '../common/Loading';

    export default {
        name: 'Form',
        components: {
            Loading,
            RightBar, LeftBar, AppHeader, Tab, step1client: ClientInfo, step1commercial: InfosCommercial,
            step2: OrganisationInfo, step3: PackInfo
        },
        data() {
            return {
                titles,
                roles,
                view: null,
                enlargeMenu: true,
                isScreenWidthMd: screen.width < 1025,
                currentTab: null,
                formShow: false,
                userNotFound: false,
                commercial: commercial(),
                subscription: subscription(),
                formComponent: {},
                title: titles.personalInfo,
                packCountryDomain: []
            };
        },
        created() {
            this.formComponent = this.$cookies.get('role') === 'ROLE_CLIENT' ? this.subscription : this.commercial;
            getClient(this.$route.params.token).then(response => {
                if (response.data === null) {
                    this.formShow = false;
                    this.userNotFound = true;
                } else {
                    this.formShow = true;
                    this.userNotFound = false;
                    this.formComponent = response.data;
                    if (response.data.roles) {
                        this.formComponent = this.commercial;
                        this.$cookies.set('role', response.data.roles[0]);
                    } else {
                        this.formComponent = this.subscription;
                        this.$cookies.set('role', response.data.organisation.client.roles[0]);
                    }
                    this.view = this.$cookies.get('role') != undefined ? this.$cookies.get('role') === this.roles.client ? 'step1client' : 'step1commercial' : null;
                    this.formComponent = response.data;
                }
            });
        },
        methods: {
            getPackCountryDomainBackOffice(packCountryDomain) {
                this.packCountryDomain = packCountryDomain;
            },
            next(formComponent, step) {
                this.formComponent = formComponent;
                if (step === 'step1') {
                    this.view = 'step2';
                } else {
                    this.view = 'step3';
                }
            },
            previous(formComponent, step) {
                this.formComponent = formComponent;
                if (step === 'step2') {
                    this.view = 'step1client';
                } else {
                    this.view = 'step2';
                }

            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/appStyle.css';
</style>
